import { createSelector } from 'reselect';

export const selectCrewMaterialTemplateSlice = state =>
  state.crewMaterialTemplates;

export const selectCrewMaterialTemplates = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.crewMaterialTemplate
);
export const crewMaterialTemplateLoaded = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.crewMaterialTemplateLoaded
);
export const selectActiveCrewMaterialTemplate = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.activeCrewMaterialTemplate
);
export const crewMaterialTemplateLastMaterial = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.lastUsedMaterial
);

export const crewMaterialTemplateMeta = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.meta
);
export const crewMaterialTemplateFilters = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.filters
);
export const crewMaterialTemplateEvent = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.eventId
);

export const crewMaterialTemplateCreating = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.isCreating
);
export const crewMaterialTemplateUpdating = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.isUpdating
);
export const crewMaterialTemplateDeleting = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.isDeleting
);
export const crewMaterialTemplateErrors = createSelector(
  selectCrewMaterialTemplateSlice,
  slice => slice.errors
);
